<template>
  <div class="tuolele-main-box">
    <div class="app-container app-margin-bottom20">
      <el-form ref="postForm" class="project_mission_form" label-width="100px" style="width:70%" :model="tyyTask" :rules="rules">
        <el-form-item label="*宝典标题" prop="valuable_name">
          <el-input v-model="tyyTask.valuable_name" placeholder="请输入标题名称" />
        </el-form-item>
        <el-form-item label="*适用日期" prop="take_date">
          <el-date-picker v-model="tyyTask.begin_date" value-format="yyyy-MM-dd" type="date" placeholder="选择开始日期" />
          <span style="margin-left: 10px;margin-right: 10px;">至</span>
          <el-date-picker v-model="tyyTask.end_date" value-format="yyyy-MM-dd" type="date" placeholder="选择结束日期" />
        </el-form-item>
        <el-form-item label="*适用年级" prop="grade_id">
          <Select key="5" :selected.sync="tyyTask.grade_id" :data="gradeLists" clearable placeholder="请选择" />
        </el-form-item>
        <el-form-item label="*适用科目" prop="subject_id">
          <Select key="5" :selected.sync="tyyTask.subject_id" :data="subjectLists" clearable placeholder="请选择" />
        </el-form-item>
        <el-form-item label="*适用教材" prop="book_id">
          <text-book-select :subject-id="tyyTask.subject_id" :selected.sync="tyyTask.teaching_type" />

        </el-form-item>
      </el-form>
      <div class="mission_list_box">
        <div v-for="(item,index) in missions" :key="'mission_'+ index" class="mission_item">
          <h2 class="project_mission_h2">任务{{ index+1 }}</h2>
          <el-form label-width="118px" class="project_mission_form" style="width:80%" label-position="left">
            <el-form-item label="所属分类">
              <el-radio-group v-model="missions[index].mission_type">
                <el-radio v-for="(radio_val,radio_index) in missionTypes" :key="'mission_type_radio_' + radio_index" style="margin-right: 13px;" :label="radio_val.id">{{ radio_val.name }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="预计花费时间">
              <el-input v-model="missions[index].mission_time" style="width: 200px;" type="number" />
            </el-form-item>
            <el-form-item label="任务标题">
              <el-input v-model="missions[index].mission_title" style="width: 100%;" type="textarea" />
            </el-form-item>
            <el-form-item label="任务项目">
              <el-table :key="'project_table_'+index + '_' + missions[index].mission_type " :data="missions[index].mission_projects">
                <el-table-column label="任务内容" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.project_value" type="textarea" />
                  </template>
                </el-table-column>
                <el-table-column v-if="missions[index].mission_type > 1" min-width="40" :label="fnGetTitleLabel(missions[index].mission_type)" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.project_id" type="textarea" />
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" min-width="15">
                  <template slot-scope="scope">
                    <el-link v-if="scope.$index>0" :underline="false" type="danger" @click.native="fnDeleteProejctItem(index,scope.$index)">删除</el-link>
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="text" @click="fnCreateMissionProject(index)">创建一个任务项目</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-button type="text" @click="fnCreateProject()">创建一个任务</el-button>
        <el-button type="primary" @click="fnSubmitForm()">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import Select from '@/components/Select'
import { validateRequire } from '@/utils/validate'
import commondata from '@/utils/commondata'
import Tool from '@/assets/js/tool.js'
import TextBookSelect from '@/components/Select/TextBookSelect'

// import TeachingTypeSelect from '@/components/Select/TeachingTypeSelect'

export default {
  components: {
    Select,
    TextBookSelect
  },
  data() {
    return {
      tyyTask: {
        valuable_id: '',
        valuable_name: '',
        subject_id: '',
        grade_id: '',
        begin_date: '',
        end_date: '',
        mission_info: '',
        teaching_type: ''
      },
      missions: [],
      missionTypes: commondata.TYY_MISSION_TYPE,
      subjectLists: commondata.TYY_SUBJECT_LISTS,
      packageTypes: commondata.TYY_PACKAGE_TYPE,
      gradeLists: commondata.GRADE_LISTS,
      rules: {
        valuable_name: [{ validator: validateRequire, trigger: 'manual', message: '标题名称' }],
        subject_id: [{ validator: validateRequire, trigger: 'manual', message: '适用科目' }],
        grade_id: [{ validator: validateRequire, trigger: 'manual', message: '适用年级' }],
        book_id: [{ validator: validateRequire, trigger: 'manual', message: '教材版本' }]
      }
    }
  },
  watch: {
    'tyyTask.subject_id': function(val) {
      this.tyyTask.book_id = ''
    }
  },
  created() {
    this.tyyTask.valuable_id = this.$route.query.id
    if (this.tyyTask.valuable_id) {
      this.fnGetParentBook()
    } else {
      this.fnCreateProject()
    }
  },
  methods: {
    // 提交
    fnSubmitForm: function() {
      if (!this.tyyTask.begin_date || !this.tyyTask.end_date) {
        this.$message({
          type: 'error',
          message: '请填开始和结束时间'
        })
        return
      }
      var self = this
      this.$refs.postForm.validate(valid => {
        if (valid) {
          this.missions.forEach((ele) => {
            ele.mission_type_name = self.missionTypes[Tool.findIndexInArryByKeyVal(self.missionTypes, 'id', ele.mission_type)].name
          })
          this.tyyTask.mission_info = JSON.stringify(this.missions)
          this.$http.tyyImproveValuable(this.tyyTask).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
              setTimeout(this.$router.push({ path: '/admin/tiyouyou/tiyouyouParentsBook' }), 2000)
            }
          })
        }
      })
    },
    fnGetParentBook() {
      this.$http.tyyValuableRowById(this.tyyTask).then(res => {
        this.tyyTask = Object.assign(this.tyyTask, res.data)
        this.$nextTick(function() {
          this.tyyTask.book_id = parseInt(res.data.book_id || '')
        })
        this.missions = res.data.mission_info
      })
    },
    fnDeleteProejctItem(index, subIndex) {
      this.missions[index].mission_projects.splice(subIndex, 1)
    },
    fnGetTitleLabel(typeId) {
      const labelsTitle = {
        '2': '常规练习ID',
        '3': '测评活动ID',
        '4': '直播活动ID',
        '5': '补充练习ID',
        '6': '知识点ID'
      }
      return labelsTitle[typeId]
    },
    fnBuildMissionProjectObj() {
      return { project_value: '', project_id: '' }
    },
    fnBuildParentBookObj() {
      return { mission_type: '1', mission_time: '', mission_title: '', mission_projects: [this.fnBuildMissionProjectObj()] }
    },
    fnCreateMissionProject(index) {
      this.missions[index].mission_projects.push(this.fnBuildMissionProjectObj())
    },
    fnCreateProject() {
      this.missions.push(this.fnBuildParentBookObj())
    }

  }
}
</script>

<style lang="scss">
  .mission_list_box .mission_item {
    background: #f5f5f5;
    padding: 20px;
    margin-bottom: 20px;
  }
  .mission_list_box .mission_item:last-child {
    margin-bottom: 0px!important;
  }
  .project_mission_form .el-form-item{
    margin-bottom: 10px;
  }
  .project_mission_h2 {
    margin-bottom: 8px;
    color:#666666;
  }
</style>
